import { render, staticRenderFns } from "./DocumentUploader.vue?vue&type=template&id=2dc15423&"
import script from "./DocumentUploader.vue?vue&type=script&lang=js&"
export * from "./DocumentUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports